import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

/* eslint-disable no-unused-expressions */
import React, { useState, useEffect } from "react";
import moment from "moment";
import { Grid, DataTable, Divider, Paper, makeStyles, Typography, numeral, setLocale, Tabs, SMPopover, DialogViewInvoice, Dialog, ToolbarSelect // Button,
// DialogSubscription,
// Create,
// Clear,
//Dialog
} from "../../../../../";
import JSZip from "jszip";
import { MyDocument } from "../../../../../core/reactPdf";
import { pdf } from "@react-pdf/renderer";
import FileSaver from "file-saver";
var useStyles = makeStyles(function (theme) {
  var _leftMain;

  return {
    leftMain: (_leftMain = {}, _defineProperty(_leftMain, theme.breakpoints.up("md"), {
      boxShadow: "15px 0 15px -5px #333"
    }), _defineProperty(_leftMain, "padding", "24px"), _defineProperty(_leftMain, "height", "100%"), _defineProperty(_leftMain, "overflowY", "scroll"), _leftMain),
    headerLeftMain: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center"
    },
    headerOpportunity: {
      display: "flex",
      "align-items": "center",
      justifyContent: "space-between"
    },
    dataOpportunity: {
      margin: "10px",
      display: "flex",
      "flex-direction": "column",
      "align-items": "left"
    },
    icon: {
      width: "80px",
      height: "auto"
    },
    contact: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      background: "#ededed45",
      borderRadius: "4px"
    },
    actionsOpportunity: {
      display: "flex",
      justifyContent: "flex-end",
      "max-width": "86%"
    },
    infoOpportunity: {
      margin: "10px",
      display: "flex",
      "flex-direction": "column",
      "align-items": "left"
    },
    divider: {
      margin: "20px 0",
      height: "4px"
    },
    mr30: {
      margin: "30px"
    },
    edit: {
      color: theme.palette.pending.main
    }
  };
});

var SubscriptionSingle = function SubscriptionSingle(_ref) {
  var translation = _ref.translation,
      subscription = _ref.subscription,
      invoices = _ref.invoices,
      invoicesToPDF = _ref.invoicesToPDF,
      getInvoicePdf = _ref.getInvoicePdf,
      invoice_pdf = _ref.invoice_pdf,
      editStatus = _ref.editStatus,
      sendNotification = _ref.sendNotification,
      handleDuplicateInvoice = _ref.handleDuplicateInvoice,
      handleDeleteInvoice = _ref.handleDeleteInvoice,
      handleAmendInvoice = _ref.handleAmendInvoice,
      handleSelectInvoicesToDownload = _ref.handleSelectInvoicesToDownload,
      handleSelectInvoicesToSend = _ref.handleSelectInvoicesToSend,
      columns = _ref.columns,
      title = _ref.title,
      options = _ref.options,
      issueNewInvoice = _ref.issueNewInvoice,
      info = _ref.info;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      openView = _useState2[0],
      setOpenView = _useState2[1]; // const [openEdit, setEditOpen] = useState(false);
  // const [openCancel, setCancelOpen] = useState(false);


  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      openDeleteInvoice = _useState4[0],
      setOpenDeleteInvoice = _useState4[1];

  var _useState5 = useState(null),
      _useState6 = _slicedToArray(_useState5, 2),
      selectedInvoice = _useState6[0],
      setSelectedInvoice = _useState6[1]; // const [invoices, setInvoices] = useState([]);
  // const [forecast_invoices, setForecastInvoices] = useState([]);


  var _useState7 = useState("forecast_invoices"),
      _useState8 = _slicedToArray(_useState7, 2),
      value = _useState8[0],
      setValue = _useState8[1]; // const [subscriptionEdit, setSubscriptionEdit] = useState({});
  // console.log("SubscriptionSingle subscription", subscription.subscription);


  var classes = useStyles();
  var optionsInvoicesPDF = {
    filter: true,
    selectableRows: true,
    filterType: "dropdown",
    responsive: "stacked",
    rowsPerPage: 10,
    customToolbarSelect: function customToolbarSelect(selectedRows) {
      return /*#__PURE__*/React.createElement(ToolbarSelect, {
        variant: "invoice",
        selectedRows: selectedRows,
        handleClick: function handleClick(type, rows) {
          rows && rows.data ? selectInvoicesToDownload(type, rows.data) : console.log("error data rows");
        }
      });
    }
  };
  useEffect(function () {
    setLocale();
  }, []);
  useEffect(function () {
    if (invoicesToPDF.length > 0) {
      var zip = new JSZip();
      Promise.all(invoicesToPDF.map(function (invoice) {
        var document = /*#__PURE__*/React.createElement(MyDocument, {
          data: invoice
        });
        return pdf(document).toBlob().then(function (blob) {
          return invoicesToPDF.length > 1 ? zip.file("".concat(moment(invoice.date).format("M"), "/").concat(invoice.docnumber.replace("/", "-"), ".pdf"), blob) : FileSaver.saveAs(blob, invoice.docnumber + ".pdf");
        });
      })).then(function (x) {
        if (invoicesToPDF.length > 1) zip.generateAsync({
          type: "blob"
        }).then(function (content) {
          FileSaver.saveAs(content, "invoices.zip");
        });
      });
    }
  }, [invoicesToPDF]); // eslint-disable-next-line no-unused-expressions

  info && columns ? columns[0].find(function (column) {
    return column.name === "options";
  }).options = {
    filter: false,
    sort: false,
    viewColumns: false,
    empty: true,
    label: false,
    customBodyRender: function customBodyRender(value, tableMeta, updateValue) {
      return !info.stripe && /*#__PURE__*/React.createElement(SMPopover, {
        data: tableMeta.rowData,
        type: "tasks",
        labels: [{
          label: "Issue invoice",
          name: "issue",
          variant: "button",
          onItemClick: handleItemIssueInvoice
        }]
      });
    }
  } : null; // eslint-disable-next-line no-unused-expressions

  info && !info.stripe ? columns ? columns[1].find(function (column) {
    return column.name === "options";
  }).options = {
    filter: false,
    sort: false,
    viewColumns: false,
    empty: true,
    label: false,
    customBodyRender: function customBodyRender(value, tableMeta, updateValue) {
      return /*#__PURE__*/React.createElement(SMPopover, {
        data: tableMeta.rowData,
        type: "invoices",
        labels: [{
          label: "View",
          name: "view",
          variant: "button",
          onItemClick: handleItemViewInvoice
        }, {
          label: "Edit",
          name: "edit",
          variant: "link",
          route: "/invoices/" + tableMeta.rowData[0] + "/edit"
        }, {
          label: "Download",
          name: "download",
          variant: "button",
          onItemClick: handleItemDownloadInvoice
        }, {
          label: "Delete",
          name: "delete",
          variant: "button",
          onItemClick: handleItemDeleteInvoicePopover
        }, {
          label: "Duplicate",
          name: "duplicate",
          variant: "button",
          onItemClick: handleItemDuplicateInvoicePopover
        }, {
          label: "Amend",
          name: "amend",
          variant: "button",
          onItemClick: handleItemAmendInvoicePopover
        }]
      });
    }
  } : null : info && info.stripe ? columns ? columns[1].find(function (column) {
    return column.name === "options";
  }).options = {
    filter: false,
    sort: false,
    viewColumns: false,
    empty: true,
    label: false,
    customBodyRender: function customBodyRender(value, tableMeta, updateValue) {
      return /*#__PURE__*/React.createElement(SMPopover, {
        data: tableMeta.rowData,
        type: "invoices",
        labels: [{
          label: "View",
          name: "view",
          variant: "button",
          onItemClick: handleItemViewInvoice
        }, {
          label: "Edit",
          name: "edit",
          variant: "link",
          route: "/invoices/" + tableMeta.rowData[0] + "/edit"
        }, {
          label: "Download",
          name: "download",
          variant: "button",
          onItemClick: handleItemDownloadInvoice
        }]
      });
    }
  } : null : null;

  var handleItemIssueInvoice = function handleItemIssueInvoice(item, id) {
    var invoice = subscription.forecast_invoices.find(function (invoice) {
      return invoice._id === id;
    });
    issueNewInvoice(invoice);
  };

  var handleItemViewInvoice = function handleItemViewInvoice(item, id) {
    // console.log("handleItemViewInvoice", item, id);
    if (!openView) {
      var invoice = invoices.find(function (invoice) {
        return invoice._id === id;
      }); // console.log("handleItemViewInvoice invoice", invoice);

      setSelectedInvoice(invoice);
    } else {
      setSelectedInvoice(null);
    }

    getInvoicePdf(id);
    setOpenView(!openView);
  };

  var handleItemDownloadInvoice = function handleItemDownloadInvoice(item, id) {
    var auxInvoices = [];
    var invoiceHandleToDownload = invoices.find(function (invoice) {
      return invoice._id === id;
    });

    if (invoiceHandleToDownload) {
      auxInvoices.push(invoiceHandleToDownload._id);
      handleSelectInvoicesToDownload(auxInvoices);
    }
  };

  var handleItemDeleteInvoicePopover = function handleItemDeleteInvoicePopover(item, id) {
    var invoice = invoices.find(function (invoice) {
      return invoice._id === id;
    });
    setSelectedInvoice(invoice);
    handleDialogDeleteInvoice();
  };

  var handleItemDuplicateInvoicePopover = function handleItemDuplicateInvoicePopover(item, id) {
    handleDuplicateInvoice(id);
  };

  var handleItemAmendInvoicePopover = function handleItemAmendInvoicePopover() {};

  var handleDialogDeleteInvoice = function handleDialogDeleteInvoice() {
    setOpenDeleteInvoice(!openDeleteInvoice);
  };

  var selectInvoicesToDownload = function selectInvoicesToDownload(type, ids) {
    var auxInvoices = [];
    ids.forEach(function (id) {
      if (invoices[id.dataIndex]) auxInvoices.push(invoices[id.dataIndex]._id);
    });

    if (type === "download") {
      handleSelectInvoicesToDownload(auxInvoices);
    } else if (type === "send") {
      handleSelectInvoicesToSend(auxInvoices);
    }
  }; // const handleDialogEdit = () => {
  //     setEditOpen(!openEdit);
  // };
  // const handleDialogCancel = () => {
  //     setCancelOpen(!openCancel);
  // };


  var tabs = [{
    label: "Next invoices",
    value: "forecast_invoices"
  }, {
    label: "Invoices",
    value: "invoices"
  }];

  var handleTabs = function handleTabs(event, newValue) {
    setValue(newValue);
  };

  var contentTabHandler = function contentTabHandler() {
    switch (value) {
      case "forecast_invoices":
        return /*#__PURE__*/React.createElement(DataTable, {
          key: invoices.length + "_forecast_invoices",
          data: subscription.forecast_invoices,
          translation: translation ? translation.datatables.invoices : null,
          columns: columns[0],
          title: title[0],
          options: options
        });

      case "invoices":
        return /*#__PURE__*/React.createElement(DataTable, {
          key: invoices.length + "_invoices",
          data: subscription.subscription_invoices,
          translation: translation ? translation.datatables.invoices : null,
          columns: columns[1],
          title: title[1],
          options: optionsInvoicesPDF
        });

      default:
        return /*#__PURE__*/React.createElement(DataTable, {
          key: invoices.length + "_forecast_invoices",
          data: subscription.forecast_invoices,
          translation: translation ? translation.datatables.invoices : null,
          columns: columns[0],
          title: title[0],
          options: options
        });
    }
  };

  return /*#__PURE__*/React.createElement(Grid, {
    container: true
  }, /*#__PURE__*/React.createElement(Dialog, {
    open: openDeleteInvoice,
    onClose: handleDialogDeleteInvoice,
    id: "modal-confirm-delete-opportunity",
    title: "Delete invoice",
    text: "Are you sure to delete this invoice? You will lose all information about this invoice",
    submit: "Delete",
    buttonColorSubmit: "secondary",
    buttonVariantSubmit: "contained",
    onCancel: handleDialogDeleteInvoice,
    cancel: "Cancel",
    buttonColorCancel: "secondary",
    buttonVariantCancel: "outlined",
    onSubmit: function onSubmit() {
      handleDeleteInvoice(selectedInvoice);
      handleDialogDeleteInvoice();
    }
  }), /*#__PURE__*/React.createElement(DialogViewInvoice, {
    variant: "view",
    open: openView,
    onClose: function onClose() {
      setOpenView(false);
    },
    invoice: selectedInvoice,
    invoice_pdf: invoice_pdf,
    editStatus: editStatus,
    sendNotification: sendNotification
  }), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 3,
    xs: 12,
    style: {
      paddingBottom: "10px",
      height: "100vh"
    }
  }, /*#__PURE__*/React.createElement(Paper, {
    className: classes.leftMain
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.headerOpportunity
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.headerLeftMain
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    color: "primary"
  }, subscription.customer || subscription.name || "Loading..."))), /*#__PURE__*/React.createElement(Divider, {
    className: classes.divider
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.dataOpportunity
  }, /*#__PURE__*/React.createElement(Typography, {
    color: "primary",
    variant: "h6"
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle1"
  }, translation ? translation.subscription_info.payment_method : "Payment method: ", " ", info && info.stripe ? "Stripe" : "Transfer/Domiciliación"), /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle1"
  }, translation ? translation.subscription_info.frequency : "Frecuency in months: ", " ", info && info.interval_count ? info.interval_count : "Loading..."), info && info.stripe ? [/*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle1"
  }, translation ? translation.subscription_info.amount : "Amount: ", " ", info && numeral(info.amount).format("0,0[.]00 $"))] : [/*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle1"
  }, translation ? translation.subscription_info.fixed : "Fixed:", " ", info && numeral(info.fixed).format("0,0[.]00 $")), /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle1"
  }, translation ? translation.subscription_info.variable : "Variable: ", " ", info && info.variable)], /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle1"
  }, translation ? translation.subscription_info.start_date : "First invoice date: ", " ", info && moment(info.start_date).format("DD/MM/YYYY")), /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle1"
  }, translation ? translation.subscription_info.status : "Status: ", info && "".concat(info.status))))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 9,
    xs: 12
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    justify: "center",
    style: {
      "padding-top": "70px"
    }
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 11
  }, /*#__PURE__*/React.createElement(Tabs, {
    value: value,
    onChange: handleTabs,
    variant: "standard",
    indicatorColor: "primary",
    textColor: "primary",
    contentTabs: tabs
  }), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 12,
    className: classes.editor
  }, contentTabHandler())))));
};

export { SubscriptionSingle };